import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import apiService from '../../server';
import { CURRENT_USER } from '../../core/data/redux/api';

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const [status, setStatus] = useState<'loading' | 'ok' | 'fail'>('loading');
  const location = useLocation();

  useEffect(() => {
    apiService.get(CURRENT_USER)
      .then(() => setStatus('ok'))
      .catch(() => setStatus('fail'));
  }, [location.pathname]);

  if (status === 'loading') return null;
  if (status === 'fail') return <Navigate to="/login" replace />;
  return <>{children}</>;
};

export default ProtectedRoute;
